var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPlus(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 42,
    viewBox: "0 0 42 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21 14.3333V21M21 21V27.6667M21 21H27.6667M21 21H14.3333M41 21C41 23.6264 40.4827 26.2272 39.4776 28.6537C38.4725 31.0802 36.9993 33.285 35.1421 35.1421C33.285 36.9993 31.0802 38.4725 28.6537 39.4776C26.2272 40.4827 23.6264 41 21 41C18.3736 41 15.7728 40.4827 13.3463 39.4776C10.9198 38.4725 8.71504 36.9993 6.85786 35.1421C5.00069 33.285 3.5275 31.0802 2.52241 28.6537C1.51732 26.2272 1 23.6264 1 21C1 15.6957 3.10714 10.6086 6.85786 6.85786C10.6086 3.10714 15.6957 1 21 1C26.3043 1 31.3914 3.10714 35.1421 6.85786C38.8929 10.6086 41 15.6957 41 21Z",
    stroke: "#478ECC",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlus);
export default __webpack_public_path__ + "static/media/plus.fc9321cc2e72718109eef6373ca40b99.svg";
export { ForwardRef as ReactComponent };